import { faPencil, faTrashCan } from '@fortawesome/pro-regular-svg-icons'
import { ActionIcon, Flex } from '@mantine/core'
import React from 'react'

import { useMutationUpdateBooking } from '@flecto/core/saas'
import { useTranslation } from '@flecto/translations'
import { type ParameterID, type CoreBookingService } from '@flecto/types'
import { Icon, useNotifications } from '@flecto/ui'

import { useModalBookingService } from '../../hooks/useModalBookingService'

export type CellActionsProps = {
  bookingId?: ParameterID
  bookingService?: CoreBookingService
}

export function CellActions({ bookingId, bookingService }: CellActionsProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'booking_services' })

  const { showNotification } = useNotifications()

  const { openModal: openModalService } = useModalBookingService({
    bookingId,
    bookingService,
  })

  const { mutateAsync: updateBooking, isLoading: isDeleting } =
    useMutationUpdateBooking()

  const handleDeleteService = async () => {
    try {
      await updateBooking({
        bookingId,
        booking: {
          booking_services_attributes: [
            {
              _destroy: true,
              id: bookingService?.id,
            },
          ],
        },
      })

      showNotification({
        type: 'success',
        message: t('notification_remove_booking_service_success'),
      })
    } catch {
      showNotification({
        type: 'error',
        message: t('notification_remove_booking_service_error'),
      })
    }
  }

  return (
    <Flex justify='flex-end' align='center' style={{ flexShrink: 0 }}>
      <ActionIcon onClick={openModalService} size='xs'>
        <Icon icon={faPencil} />
      </ActionIcon>
      <ActionIcon onClick={handleDeleteService} size='xs' loading={isDeleting}>
        <Icon icon={faTrashCan} />
      </ActionIcon>
    </Flex>
  )
}
